<template>
  <div class="form-group">
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        class="custom-control-input"
        :id="idCampo"
        :checked="!!value"
        :disabled="disabled"
        @change="$emit('input', $event.target.checked)"
      />
      <label class="custom-control-label" :for="idCampo">{{ campo.label }}</label>
    </div>
    <div v-if="erro" class="avisoDanger text-left mt-1">{{ erro }}</div>
  </div>
</template>

<script>
export default {
  name: 'CampoToggle',
  props: {
    idCampo: { type: String, required: true },
    campo: { type: Object, required: true },
    value: { default: false },
    erro: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  }
}
</script>
